import { useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setAllGroupUser } from "../../../../redux/TaskGroupingSlice";
import { getGroupedUsers } from "../utils/reportUtils";

export function useReportHeaderState() {
  const dispatch = useDispatch();
  const [isVisible, setIsVisible] = useState(false);
  const groupingUser = useSelector(
    (state) => state.groupingUser.allocationUsers
  );

  const users = useMemo(() => getGroupedUsers(groupingUser), [groupingUser]);

  const clearFilters = useCallback(() => {
    dispatch(setAllGroupUser([]));
  }, [dispatch]);

  const handleVisibilityChange = useCallback(
    (value) => {
      setIsVisible(value);
      if (!value) {
        clearFilters();
      }
    },
    [clearFilters]
  );

  return {
    isVisible,
    users,
    handleVisibilityChange,
  };
}
